import axios from 'axios'

class UsuarioApiClient {

    async buscarLogado(produtoId) {
        return await axios.get(`/hal/usuario/sessao?produtoId=${produtoId}`)
    }

    async editar(payload) {
        return await axios.post('/hal/editarUsuario', payload)
    }

    buscarDadosSessaoUsuario() {
        return axios.get('/hal/auth/usuario/info')
    }
}

export default new UsuarioApiClient()
